<script>

</script>

<div>
    <img src="images/oslomet_logo.png">
</div>

<style>
    div {
        display: flex;
        flex: 0 0 100%;
        flex-flow: row nowrap;
        background-color: rgb(255, 220, 0);
    }

    img {
        width: 80px;
        margin: 0.5em 0 0.5em 1em;
    }
</style>
